import React from 'react';


export default class Component extends React.Component {

  render = () => {
    return (
      <div>

        お探しのページは見つかりませんでした。   

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/App/NotFound.jsx